<script lang="ts">
    // import src from '../../../assets/material_timer.svg';
    import src from './svg/official/OverTime.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;
    export let title: string = '';

    scale = scale * 1.15;
</script>

<TemplateIcon {src} {scale} alt={title} hover={title} on:click />
